import { SupportedChainId } from 'constants/chains'

type AddressMap = { [chainId: number]: string }

export const V2_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.HAUST]: '',
  [SupportedChainId.HAUST_TESTNET]: ''
}
export const V2_ROUTER_ADDRESS: AddressMap = {
  [SupportedChainId.HAUST]: '0xA235A9DdE3eAa4ca42D137ef48368f8FABeB7DaE',
  [SupportedChainId.HAUST_TESTNET]: '0xA235A9DdE3eAa4ca42D137ef48368f8FABeB7DaE',
}

export const PERMIT2_ADDRESS: AddressMap = {
  [SupportedChainId.HAUST]: '',
  [SupportedChainId.HAUST_TESTNET]: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
}

// HAUST Testnet addresses
const HAUST_TESTNET_V3_CORE_FACTORY_ADDRESSES = '0xfa34400B1B8dcFd909Eac942053097ed5903f1D3'
const HAUST_TESTNET_V3_MIGRATOR_ADDRESSES = '0xfa34400B1B8dcFd909Eac942053097ed5903f1D3'
const HAUST_TESTNET_MULTICALL_ADDRESS = '0xf96ebA28E151594e5995f3Dbc5CF7E9b1F479998'
const HAUST_TESTNET_QUOTER_ADDRESSES = '0x6c1C7768D6Bc68A3b769d482d3b54c3396Fda3Ee'
const HAUST_TESTNET_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = '0xA8ecBe9F78f9084C3978949c63EeB0091762A0f9'
const HAUST_TESTNET_UNISWAP_V3_STAKER_ADDRESSES = '0x94a8EFd7344Cd4eb8DDbCa213CB2BC4Ee9Fa5d91'
const HAUST_TESTNET_TICK_LENS_ADDRESSES = '0xaa8D31911533C1ea020e5FFB1B1EF2E7aB99320F'
const HAUST_TESTNET_POOL_DEPLOYER = '0xfa34400B1B8dcFd909Eac942053097ed5903f1D3'
const HAUST_TESTNET_UNIVERSAL_ROUTER_ADDRESS = '0x0913b6edfBfc3CC37538304fE81dBAB050D73D1c'
const HAUST_TESTNET_V3_INIT_POOL_CODE_HASH = '0xe34f199b19b2b4f47f68442619d555527d244f78a3297ea89325f843f87b8b54'


// HAUST addresses
const BSC_V3_CORE_FACTORY_ADDRESSES = ''
const BSC_V3_MIGRATOR_ADDRESSES = ''
const BSC_MULTICALL_ADDRESS = ''
const BSC_QUOTER_ADDRESSES = ''
const BSC_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = ''
const BSC_TICK_LENS_ADDRESSES = ''
const BSC_POOL_DEPLOYER = ''
const BSC_UNIVERSAL_ROUTER_ADDRESS = ''

/* V3 Contract Addresses */
export const V3_CORE_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.HAUST_TESTNET]: HAUST_TESTNET_V3_CORE_FACTORY_ADDRESSES,
  [SupportedChainId.HAUST]: BSC_V3_CORE_FACTORY_ADDRESSES,
}

export const V3_MIGRATOR_ADDRESSES: AddressMap = {
  [SupportedChainId.HAUST_TESTNET]: HAUST_TESTNET_V3_MIGRATOR_ADDRESSES,
  [SupportedChainId.HAUST]: BSC_V3_MIGRATOR_ADDRESSES,
}

export const MULTICALL_ADDRESS: AddressMap = {
  [SupportedChainId.HAUST_TESTNET]: HAUST_TESTNET_MULTICALL_ADDRESS,
  [SupportedChainId.HAUST]: BSC_MULTICALL_ADDRESS,
}

export const ARGENT_WALLET_DETECTOR_ADDRESS: AddressMap = {}

export const QUOTER_ADDRESSES: AddressMap = {
  [SupportedChainId.HAUST_TESTNET]: HAUST_TESTNET_QUOTER_ADDRESSES,
  [SupportedChainId.HAUST]: BSC_QUOTER_ADDRESSES,
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  [SupportedChainId.HAUST_TESTNET]: HAUST_TESTNET_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
  [SupportedChainId.HAUST]: BSC_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
}

export const UNISWAP_V3_STAKER_ADDRESSES: AddressMap = {
  [SupportedChainId.HAUST_TESTNET]: HAUST_TESTNET_UNISWAP_V3_STAKER_ADDRESSES,
}

export const ENS_REGISTRAR_ADDRESSES: AddressMap = {}

export const TICK_LENS_ADDRESSES: AddressMap = {
  [SupportedChainId.HAUST_TESTNET]: HAUST_TESTNET_TICK_LENS_ADDRESSES,
  [SupportedChainId.HAUST]: BSC_TICK_LENS_ADDRESSES,
}

export const POOL_DEPLOYER_ADDRESSES: AddressMap = {
  [SupportedChainId.HAUST_TESTNET]: HAUST_TESTNET_POOL_DEPLOYER,
  [SupportedChainId.HAUST]: BSC_POOL_DEPLOYER,
}

export const UNIVERSAL_ROUTER_ADDRESS: AddressMap = {
  [SupportedChainId.HAUST_TESTNET]: HAUST_TESTNET_UNIVERSAL_ROUTER_ADDRESS,
  [SupportedChainId.HAUST]: BSC_UNIVERSAL_ROUTER_ADDRESS,
}

export const V3_INIT_POOL_CODE_HASH: AddressMap = {
  [SupportedChainId.HAUST_TESTNET]: HAUST_TESTNET_V3_INIT_POOL_CODE_HASH
}
